import axios from "./axios";
import { userData } from "./Currentuserdata";

export default {
  /**
   * Get All Customers
   * @api {Get} managecustomer
   */
  getFamilies(data) {
    const user = userData();
    const options = {
      method: "GET",
      url: "items/getallfam",
      headers: { "content-type": "application/json" },
      params: {
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  getFamiliesHistory(data) {
    const user = userData();
    const options = {
      method: "GET",
      url: "items/getallfam/list/history",
      headers: { "content-type": "application/json" },
      params: {
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  getFamiliesFiltered(data) {
    const user = userData();
    const options = {
      method: "GET",
      url: "items/getallfam/list/filtered",
      headers: { "content-type": "application/json" },
      params: {
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data,
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createData(data) {
    const options = {
      method: "POST",
      url: 'items/importDataTypes',
      headers: {'content-type': 'application/json'},
      data: data
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createFam(data) {
    const user = userData();
    const options = {
      method: "POST",
      url: 'items/fam',
      headers: {'content-type': 'application/json'},
      data:{
        name: data.name,
        ID_Printer: data.ID_Printer,
        ID_Branch: user.branch,
        ID_Business: user.businessid,
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createCat(data) {
    const user = userData();
    const options = {
      method: "POST",
      url: `items/cat`,
      headers: {'content-type': 'application/json'},
      data:{
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data 
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  createSub(data) {
    const user = userData();
    const options = {
      method: "POST",
      url: `items/sub`,
      headers: {'content-type': 'application/json'},
      data:{
        ID_Branch: user.branch,
        ID_Business: user.businessid,
        ...data
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.messageageage);
        });
    });
  },

  getOneFam(id) {
    const user = userData();
    const options = {
      method: "GET",
      url: `items/getonefam/${id}`,
      headers: {'content-type': 'application/json'},
      data: {
        ID_Branch: user.branch,
        ID_Business: user.businessid        ,
      }
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
updateFam(data){
  const user = userData();
  const options = {
    method: "PUT",
    url: `items/fam/${data.id}`,
    headers: {'content-type': 'application/json'},
    data:{
      ID_Branch: user.branch,
      ID_Business: user.businessid,
      name: data.name,
      ID_Printer: data.ID_Printer,
      ID_ItemPrinter: data.ID_ItemPrinter
    }
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });

},
deleteFam(id){
  const user = userData();
  const options = {
    method: "DELETE",
    url: `items/fam/${id}`,
    headers: {'content-type': 'application/json'},
    data: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
    }
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });

},
/* end items families */

getCategories(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "items/getallcat",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
getCategoriesByFamily( data ) {
  const options = {
    method: "GET",
    url: "items/famgetcats",
    headers: { "content-type": "application/json" },
    params: {
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        //console.log( 'response fam/getallcat ', response );
        resolve(response.data);
      })
      .catch((error) => {
        //console.log( error );
        reject(error.message);
      });
  });
},
getCategoriesHistory(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "items/getallcat/list/history",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getCategoriesFiltered(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "items/getallcat/list/filtered",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getOneCat(id) {
  const user = userData();
  const options = {
    method: "GET",
    url: `items/getonecat/${id}`,
    headers: {'content-type': 'application/json'},
    data: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
    }
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
updateCat(data){
const user = userData();
const options = {
  method: "PUT",
  url: `items/cat/${data.id}`,
  headers: {'content-type': 'application/json'},
  data:{
    ID_Branch: user.branch,
    ID_Business: user.businessid,
    name: data.name,
    ID_Printer: data.ID_Printer,
    ID_ItemPrinter: data.ID_ItemPrinter
  }
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
deleteCat(id){
const user = userData();
const options = {
  method: "DELETE",
  url: `items/cat/${id}`,
  headers: {'content-type': 'application/json'},
  data: {
    ID_Branch: user.branch,
    ID_Business: user.businessid        ,
  },
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
/* end items categories */

getSubs(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "items/getallsub",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
getSubsByCategory(data) {
  const options = {
    method: "GET",
    url: "items/catgetsubs",
    headers: { "content-type": "application/json" },
    params: {
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getSubsHistory(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "items/getallsub/list/history",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getSubsFiltered(data) {
  const user = userData();
  const options = {
    method: "GET",
    url: "items/getallsub/list/filtered",
    headers: { "content-type": "application/json" },
    params: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
      ...data
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},

getOneSub(id) {
  const user = userData();
  const options = {
    method: "GET",
    url: `items/getonesub/${id}`,
    headers: {'content-type': 'application/json'},
    data: {
      ID_Branch: user.branch,
      ID_Business: user.businessid        ,
    },
  };
  return new Promise((resolve, reject) => {
    axios(options)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.message);
      });
  });
},
updateSub(data){
const user = userData();
const options = {
  method: "PUT",
  url: `items/sub/${data.id}`,
  headers: {'content-type': 'application/json'},
  data:{
    ID_Branch: user.branch,
    ID_Business: user.businessid,
    name: data.name,
    ID_Printer: data.ID_Printer,
    ID_ItemPrinter: data.ID_ItemPrinter
  }
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
deleteSub(id){
const user = userData();
const options = {
  method: "DELETE",
  url: `items/sub/${id}`,
  headers: {'content-type': 'application/json'},
  data: {
    ID_Branch: user.branch,
    ID_Business: user.businessid        ,
  },
};
return new Promise((resolve, reject) => {
  axios(options)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.message);
    });
});

},
/* end items subcategories */

  getBrands(data) {
    const options = {
      method: "GET",
      url: "items/getBrands",
      headers: { "content-type": "application/json" },
      params: {
        ...data
      },
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },

  addBrand(data) {
    const options = {
      method: "POST",
      url: "items/addBrand",
      headers: { "content-type": "application/json" },
      data: data
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },

  deleteBrand(data) {
    const options = {
      method: "POST",
      url: "items/deleteBrand",
      headers: { "content-type": "application/json" },
      data: data
    };
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  },
  
  // Métodos de paginación para carga virtual
  findAllFamiliesPaginated(data = {}) {
    const user = userData();
    //console.log('findAllFamiliesPaginated - userData:', user);
    const options = {
      method: "GET",
      url: "items/getallfam/paginated",
      headers: { 
        "content-type": "application/json",
        "id_business": user.businessid
      },
      params: {
        page: data.page || 1,
        limit: data.limit || 20,
      },
    };
    //console.log('findAllFamiliesPaginated - options:', options);
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          //console.log('findAllFamiliesPaginated - response:', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          //console.log('findAllFamiliesPaginated - error:', error);
          reject(error.message);
        });
    });
  },

  findCategoriesByFamilyPaginated(familyId, data = {}) {
    const user = userData();
    //console.log('findCategoriesByFamilyPaginated - userData:', user);
    const options = {
      method: "GET",
      url: "items/getallcat/findByFamilyPaginated",
      headers: { 
        "content-type": "application/json",
        "id_business": user.businessid
      },
      params: {
        id_family: familyId,
        page: data.page || 1,
        limit: data.limit || 20,
      },
    };
    //console.log('findCategoriesByFamilyPaginated - options:', options);
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          //console.log('findCategoriesByFamilyPaginated - response:', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          //console.log('findCategoriesByFamilyPaginated - error:', error);
          reject(error.message);
        });
    });
  },

  findSubcategoriesByCategoryPaginated(categoryId, data = {}) {
    const user = userData();
    //console.log('findSubcategoriesByCategoryPaginated - userData:', user);
    const options = {
      method: "GET",
      url: "items/getallsub/findByCategoryPaginated",
      headers: { 
        "content-type": "application/json",
        "id_business": user.businessid,
        "id_branch": user.branch
      },
      params: {
        id_cat: categoryId,
        page: data.page || 1,
        limit: data.limit || 20,
      },
    };
    //console.log('findSubcategoriesByCategoryPaginated - options:', options);
    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          //console.log('findSubcategoriesByCategoryPaginated - response:', response.data);
          resolve(response.data);
        })
        .catch((error) => {
          //console.log('findSubcategoriesByCategoryPaginated - error:', error);
          reject(error.message);
        });
    });
  },
};
